export const PorteringStatuses = [
    {
      title: 'ED Ready',
      code: 'ED'
    },
    {
      title: 'Radiology Ready',
      code: 'RR',
    }
]